// extracted by mini-css-extract-plugin
module.exports = {"UserStatistics":"styles_UserStatistics__1lBTj","box":"styles_box__1pAMs","label":"styles_label__kyDGJ","value":"styles_value__2W0qz"};